import { render, staticRenderFns } from "./CompanyAdminSUP.vue?vue&type=template&id=fd64120a&scoped=true"
import script from "./CompanyAdminSUP.vue?vue&type=script&lang=js"
export * from "./CompanyAdminSUP.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd64120a",
  null
  
)

export default component.exports